import { SystemLabel } from './system-label';

export class RestockSystemLabel extends SystemLabel {}
